import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { Avatar as AvatarIcon } from '@paypalcorp/pp-react'
import styles from './avatar.less'
import Icon from '../icon'

export const avatarColors = ['blue', 'purple', 'green']

class Avatar extends React.Component {
  static propTypes = {
    icon: PropTypes.string,
    imageUrl: PropTypes.string,
    initials: PropTypes.string,
    backgroundColor: PropTypes.oneOf(avatarColors),
    blank: PropTypes.bool,
    glow: PropTypes.bool,
    small: PropTypes.bool,
  }

  render() {
    let avatarStyle = {}
    const backgroundStyle = this.props.backgroundColor || 'transparent'
    let noAvatarElement = ''
    if (!this.props.blank) {
      if (this.props.imageUrl) {
        avatarStyle.backgroundImage = `url("${this.props.imageUrl}")`
      }

      if (!this.props.imageUrl) {
        if (this.props.icon) {
          noAvatarElement = (
            <Icon iconSize="huge" type={this.props.icon} strokeColor="white" />
          )
        } else if (this.props.initials) {
          noAvatarElement = (
            <AvatarIcon
              initials={this.props.initials}
              color={this.props.backgroundColor || 'blue'}
            />
          )
        } else {
          noAvatarElement = <AvatarIcon icon="user" />
        }
      }
    }

    const stylesArray = ['avatar', backgroundStyle]
    if (this.props.blank) stylesArray.push('blank')
    if (this.props.glow) stylesArray.push('glow')
    if (this.props.small) stylesArray.push('smaller-shadow')

    return (
      <div styleName={stylesArray.join(' ')} style={avatarStyle}>
        {noAvatarElement}
      </div>
    )
  }
}

export default cssModules(Avatar, styles, { allowMultiple: true })
